module.exports = __webpack_public_path__ + "img/fumbi-footer-logo.5fed1653.svg";